<script setup>

const props = defineProps({
    session: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['close']);

const closeModal = () => {
    emit('close');
};

const viewFavorites = () => {
    const link = `/agenda?view=favorites`;
    navigateTo(link, { external: true, replace: true });
};
</script>

<template>
    <div>
        <h2>“{{ session.title }} has been added to My Favorites!</h2>
        <div class="modal-alert">
            <MessSvg class="warning-icon" type="warning" />
            <p class="fs-16">
                This session has a limited number of seats available and requires a seat reservation, however, HubSpot
                employees
                cannot reserve seats for limited-capacity sessions. This ensures our customers and paid attendees get
                seats in rooms
                for breakout content.
            </p>
        </div>
        <div class="modal-action-buttons">
            <ProjectButtonSecondary type="submit" :disabled="isFavoriteLoading" :loading="isFavoriteLoading"
                :filledIn="true" @click="viewFavorites">View My Favorites</ProjectButtonSecondary>
            <ProjectButtonSecondary type="submit" :disabled="isFavoriteLoading" :loading="isFavoriteLoading"
                @click="closeModal">Close</ProjectButtonSecondary>
        </div>
    </div>
</template>
